import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { delay } from 'rxjs/internal/operators/delay'
import { Deps, State } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { from } from 'rxjs'
import { Future } from 'funfix'
import { getToken } from 'src/users-components/login/login.reducer'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'
import { testsNamesActions, TestsNamesActions } from './testsNames.actions'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

interface Action$ extends ActionsObservable<TestsNamesActions> {}
interface State$ extends StateObservable<State> {}

const loadTestsNames = (state$: State$, dsService: DSService) => (p: { [startFetch]: string }) =>
  delay<TestsNamesActions>(300)(
    from(
      pipe(
        getToken(state$.value),
        O.fold(
          () => Future.pure(testsNamesActions.LoadTestsNamesFailed({ [stopFetch]: p[startFetch] })),
          token =>
            dsService
              .getTestsNames(token)
              .map(testsOpt =>
                pipe(
                  testsOpt,
                  O.fold(
                    () => testsNamesActions.LoadTestsNamesFailed({ [stopFetch]: p[startFetch] }),
                    tests =>
                      testsNamesActions.LoadTestsNamesSuccess({ testsNames: tests.result, [stopFetch]: p[startFetch] })
                    )
                  )
              )
        )
      )
    )
  )

export const loadTestsNamesEpic = (action$: Action$, state$: State$, deps: Deps) =>
  action$.pipe(
    filter(testsNamesActions.is.LoadTestsNames),
    mergeMap(loadTestsNames(state$, deps.dsService))
  )

export const testsNamesEpics = combineEpics(loadTestsNamesEpic)



// WEBPACK FOOTER //
// ./src/tests-components/select-tests-names/testsNames.epics.ts